import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { STATUS } from "utils/status";
import { AnalyticsCompletedState } from '../interfaces/interface';
import { getCompletedAnalytics } from '../slices/analytics/completed';

const ExtraReducers = (builder: ActionReducerMapBuilder<AnalyticsCompletedState>) => {
  builder
  .addCase(getCompletedAnalytics.pending, (state) => {
    state.getStatus = STATUS.PENDING;
    state.createMessage = null
  })
  .addCase(getCompletedAnalytics.fulfilled, (state, action) => {
    state.getStatus = STATUS.SUCCESS;
    state.analyticsCompleted = action.payload;
    state.createMessage = null
  })
  .addCase(getCompletedAnalytics.rejected, (state, action:any) => {
    state.getStatus = STATUS.FAILED;
    state.createMessage = action.payload?.message || "An error is occurred"
  });
};

export default ExtraReducers;

